import { render, staticRenderFns } from "./ConferenceDetailModal.vue?vue&type=template&id=408b7450"
import script from "./ConferenceDetailModal.vue?vue&type=script&lang=js"
export * from "./ConferenceDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports